/*
 * DELIBERATE DECISION — do not make these URLs stage-aware.
 *
 * Unlike projects/cdn (which uses a '{{ STAGE }}' token replaced at deploy time),
 * the demo site intentionally pins its external URLs regardless of the stage it
 * is deployed to. Both are pinned to LATEST, on every stage, under the one demo
 * dealer key:
 *   - inventory JSON: the demo dealer's own feed. staticInventoryUpload-worker.ts
 *     publishes it to the latest CDN bucket because the dealer's
 *     adminSettings.demoDealer is true
 *   - FPDXP integration script: the demo showcases the newest integration build
 * Both come from the same dealer on the same environment, so the vehicles a page
 * lists and the payments its widgets price come from the same rows.
 * Do not introduce '{{ STAGE }}' tokens, getStagedUrl-style helpers, or per-stage
 * key maps here. See projects/demo/docs/README.md for the full rationale.
 */

// the demo dealer's install key (dealer 700001 on latest); update only if the demo dealer changes
const DEMO_DEALER_KEY = '79oTii2K4nKD0zAOmfbp7';

// REF: demo-site-config-inventory-url
export const INVENTORY_URL = `https://cdn.latest.flexpathdxp.com/inventory/${DEMO_DEALER_KEY}.json`;
const INTEGRATION_SCRIPT_URL = `https://cdn.latest.flexpathdxp.com/integrations/${DEMO_DEALER_KEY}.js`;

// The FPDXP integration scans placeholder elements on load and then reacts only to
// added elements and to in-place VIN changes on already-integrated SVP placeholders,
// so pages that render placeholders dynamically (the VDP) call this only after the
// real VIN/stock classes are in place. Static pages load it via a plain <script async>
// head tag instead (see the HTML pages).
// REF: demo-site-config-load-integration-script
export function loadIntegrationScript(): void {
  const script = document.createElement('script');
  script.async = true;
  script.src = INTEGRATION_SCRIPT_URL;
  document.body.appendChild(script);
}
